import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiLightningBolt } from 'react-icons/hi';
import axiosInstance from '../../utils/axiosInstance';

const BreakingNews = () => {
  const [recentBlogs, setRecentBlogs] = useState([]);

  useEffect(() => {
    const fetchRecent = async () => {
      try {
        const { data } = await axiosInstance.get('/blogs/recent');
        setRecentBlogs([...data, ...data]); 
      } catch (error) {
        console.error("Failed to fetch recent blogs:", error);
      }
    };
    fetchRecent();
  }, []);

  if (recentBlogs.length === 0) {
    return null;
  }

  return (
    <div className="container mx-auto px-6 my-8">
      {/* --- ADD A HEIGHT CLASS (h-16) TO THIS DIV --- */}
      <div className="bg-white shadow-md rounded-lg flex items-center overflow-hidden h-16">
        
        {/* "Breaking" Label */}
        <div className="bg-red-600 text-white font-bold uppercase p-3 flex items-center gap-2 h-full">
          <HiLightningBolt size={20} />
          <span>Breaking</span>
        </div>
        
        {/* Ticker Viewport */}
        <div className="flex-grow overflow-hidden relative h-full">
          <div className="absolute top-0 left-0 h-full w-full flex items-center">
            <div className="news-ticker-content flex items-center h-full">
              {recentBlogs.map((blog, index) => (
                <Link to={`/blog/${blog.id}`} key={`${blog.id}-${index}`} className="flex items-center gap-3 px-4 whitespace-nowrap text-gray-700 hover:bg-gray-100 h-full">
                  {blog.image && <img src={blog.image} alt="" className="w-10 h-10 object-cover rounded-sm" />}
                  <div>
                    <span className="text-xs font-semibold text-indigo-600">{blog.category_name || 'General'}</span>
                    <p className="text-sm font-medium">{blog.title}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* "View All" Link */}
    
      </div>
    </div>
  );
};

export default BreakingNews;